import {
  Box,
  Button,
  Checkbox,
  Flex,
  Image,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useTabs,
  Heading,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  Switch,
  ModalOverlay,
  Modal,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BASE_URL_EVENT,
  BASE_URL_MEDIA,
  getEventDetails,
} from "../../Redux/App/action";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import invitationBG from "../../assets/InvitationBg.png";
import download from "downloadjs";
import {
  BiLogoWhatsapp,
  BiLogoTelegram,
  BiDownload,
  BiLink,
} from "react-icons/bi";
import { CanvasContext } from "../../Components/core/workspace/CanvasContext";
import { useParams } from "react-router";
const NextRsvp = () => {
  const { canvas } = useContext(CanvasContext);
  const [excelData, setExcelData] = useState([]);
  const [previewRes, setPreviewRes] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const accessToken = localStorage.getItem("token");
  const dispatch = useDispatch();
  const toast = useToast();
  const [activeTab, setActiveTab] = useState(0);
  const { allEvents } = useSelector((store) => store.appReducer);
  const [eventName, seteventName] = useState("");
  const [eventType, seteventType] = useState("");
  const [venue, setvenue] = useState("");
  const [eventDetails, seteventDetails] = useState("");
  const [eventTiming, seteventTiming] = useState("");
  const [expectedNoOfGuests, setexpectedNoOfGuests] = useState("");
  const [venuePinCode, setvenuePinCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [comment, setComment] = useState(false);
  const [upiId, setupiId] = useState("");
  const [optionalSourceImgId, setoptionalSourceImgId] = useState(0);
  const [tid, setTid] = useState("");
  const imageRef = useRef(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [eventId, seteventId] = useState("");
  const calender = useRef(null);
  const [imageId, setImageId] = useState([]);
  const [addwishlist, setAddWishlist] = useState(false);
  const [authorize, setAuthorize] = useState(false);
  const [downloading, setDownloding] = useState(false);
  const [rsvp, setRsvp] = useState(false);
  const [eshagun, setEshagun] = useState(false);
  const [authorizeMemberList, setInputFields] = useState([
    { name: "", mobile: "" },
  ]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [webview, setWebview] = useState(false);
  const [accomodation, setAccomodation] = useState(false);
  const [fligth, setfligth] = useState(false);
  const [invitationDetailsWa, setInvitationDetailsWa] = useState(false);

  const eventIdLocal = localStorage.getItem("eventId");
  const param = useParams();
  const eventsId = param._eventid;

  useEffect(() => {
    const buildString = navigator.userAgent.includes("Build");
    const sysType = navigator.userAgent.includes("Linux");
    const osType = navigator.userAgent.includes("Android");
    setWebview(buildString && sysType && osType);
  }, []);

  useEffect(() => {
    getEventData();
  }, []);

  const getEventData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_EVENT}/get-event?id=${eventsId}`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      if (response.data && response.data.payload) {
        const {
          eventName,
          eventType,
          venue,
          eventDetails,
          upiId,
          e_shugan_enabled,
          eventTiming,
          expectedNoOfGuests,
          venuePinCode,
          venueImg,
          venueImgUrl,
        } = response.data.payload;

        // Check for null/undefined values before setting state
        seteventName(eventName || "");
        seteventType(eventType || "");
        setvenue(venue || "");
        seteventDetails(eventDetails || "");
        setupiId(upiId || "");
        setEshagun(e_shugan_enabled || false);
        seteventTiming(eventTiming || "");
        setexpectedNoOfGuests(expectedNoOfGuests || "");
        setvenuePinCode(venuePinCode || null);
        setSelectedImages(venueImgUrl || null);
      }
    } catch (error) {
      console.error("Error fetching event data: ", error);
    }
  };

  // Initialize the invitationDetails as an object with an empty guests array
  const [invitationDetails, setInvitationDetails] = useState({
    guests: [{ name: "", mobile: "", email: "" }],
  });
  const [manualData, setManualData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleDownload = () => {
    download(previewRes, "CustomizedPreviewImage.jpg");
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [guests, setGuests] = useState([]);
  // Function to handle guest name change
  const handleGuestNameChange = (index, event) => {
    const { name, value } = event.target;
    const newGuestList = [...invitationDetails.guests];
    newGuestList[index][name] = value;
    setInvitationDetails({ ...invitationDetails, guests: newGuestList });
  };

  // Function to handle guest mobile change
  const handleGuestMobileChange = (index, event) => {
    const { name, value } = event.target;
    const newGuestList = [...invitationDetails.guests];
    newGuestList[index][name] = value;
    setInvitationDetails({ ...invitationDetails, guests: newGuestList });
  };

  // Function to handle guest email change
  const handleGuestEmailChange = (index, event) => {
    const { name, value } = event.target;
    const newGuestList = [...invitationDetails.guests];
    newGuestList[index][name] = value;
    setInvitationDetails({ ...invitationDetails, guests: newGuestList });
  };

  // Function to add a new guest entry
  const handleAddGuest = () => {
    const newGuestList = [
      ...invitationDetails.guests,
      { name: "", mobile: "", email: "" },
    ];
    setInvitationDetails({ ...invitationDetails, guests: newGuestList });
    setInvitationDetailsWa(true);
  };

  // Function to remove a guest entry
  const handleRemoveGuest = (index) => {
    const newGuestList = [...invitationDetails.guests];
    newGuestList.splice(index, 1);
    setInvitationDetails({ ...invitationDetails, guests: newGuestList });
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "exportedData.xlsx");
  };

  const handleFileChange = (e) => {
    const files = e.target.files;

    if (files.length > 10) {
      setErrorMessage("You can only upload a maximum of 10 images.");
      e.target.value = ""; // Clear the selected files
    } else {
      setErrorMessage("");
      setSelectedImages(Array.from(files));
      // Handle the selected files here
    }
  };

  {
    /*   useEffect(() => {
    dispatch(getEventDetails);
  }, [dispatch]); */
  }

  const handleImage = () => {
    const formData = new FormData();

    formData.append("productFiles", ...selectedImages);
    axios
      .post(
        `${BASE_URL_MEDIA}/media/file/admin/upload/productfiles?imageGroup=PRODUCT`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: "123456",
          },
        },
      )
      .then((response) => {
        setImageId(response.data);
        setoptionalSourceImgId(response.data[0].sourceMediaId);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  const [isLoading, setLoading] = useState(false);

  const HandleSubmitEmail = () => {
    const formData = new FormData();
    formData.append("eventId", 10);
    formData.append("eventOptionRequestDto.accomodationFlag", accomodation);
    formData.append("eventOptionRequestDto.flightFlag", fligth);
    formData.append("eventOptionRequestDto.requestRSVP", rsvp);
    formData.append("eventOptionRequestDto.allowCommentsWall", comment);
    formData.append(
      "eventOptionRequestDto.authorizeMemeberToManage",
      authorize,
    );
    formData.append("eventOptionRequestDto.eshagunFlag", eshagun);
    formData.append("eventRequestDTO.eventName", eventName);
    formData.append("eventRequestDTO.eventType", eventType);
    formData.append("eventRequestDTO.venue", address1);
    formData.append("eventRequestDTO.venuePincode", venuePinCode);
    formData.append("eventRequestDTO.eventDetails", eventDetails);
    formData.append("eventRequestDTO.eventTiming", eventTiming);
    formData.append("eventRequestDTO.expectedNoOfGuests", expectedNoOfGuests);
    formData.append("eventRequestDTO.venueImg", imageId);
    authorizeMemberList.forEach((inputFields, index) => {
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberName`,
        inputFields.name,
      );
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberMobileNo`,
        inputFields.mobile,
      );
    });
    formData.append("upiId", upiId);
    formData.append("invitationHistoryRequestDto.templateId", tid);
    formData.append("invitationHistoryRequestDto.sharingModeType", "EMAIL");
    formData.append("invitationHistoryRequestDto.sourceMediaId", imageId);
    formData.append("invitationHistoryRequestDto.base64", base64Img);
    formData.append(
      `invitationHistoryRequestDto.invitationDetailsProvided`,
      invitationDetailsWa,
    );
    formData.append(
      "invitationHistoryRequestDto.invitationDetails[0].sourceMediaId",
      "426",
    );
    invitationDetails.guests.forEach((inputFields, index) => {
      formData.append(
        `invitationHistoryRequestDto.invitationDetails[${index}].guestName`,
        inputFields.name,
      );
      formData.append(
        `invitationHistoryRequestDto.invitationDetails[${index}].guestPhoneNumber`,
        inputFields.mobile,
      );
      formData.append(
        `invitationHistoryRequestDto.invitationDetails[${index}].guestEmail`,
        inputFields.email,
      );
    });

    axios
      .post(`${BASE_URL_EVENT}/invitation/card/display`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        toast({
          title: "Invitation Send Succesfully Via Mail!",
          status: "success",
          duration: 5000,
          position: "top",
          isClosable: true,
        });
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  function exitWebView(event) {
    event.preventDefault();
    const formData = new FormData();
    formData.append("eventId", 10);
    formData.append("eventOptionRequestDto.accomodationFlag", accomodation);
    formData.append("eventOptionRequestDto.flightFlag", fligth);
    formData.append("eventOptionRequestDto.requestRSVP", rsvp);
    formData.append("eventOptionRequestDto.allowCommentsWall", comment);
    formData.append(
      "eventOptionRequestDto.authorizeMemeberToManage",
      authorize,
    );
    formData.append("eventOptionRequestDto.eshagunFlag", eshagun);
    formData.append("eventRequestDTO.eventName", eventName);
    formData.append("eventRequestDTO.eventType", eventType);
    formData.append("eventRequestDTO.venue", address1);
    formData.append("eventRequestDTO.venuePincode", venuePinCode);
    formData.append("eventRequestDTO.eventDetails", eventDetails);
    formData.append("eventRequestDTO.eventTiming", eventTiming);
    formData.append("eventRequestDTO.expectedNoOfGuests", expectedNoOfGuests);
    formData.append("eventRequestDTO.venueImg", imageId);
    authorizeMemberList.forEach((inputFields, index) => {
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberName`,
        inputFields.name,
      );
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberMobileNo`,
        inputFields.mobile,
      );
    });
    formData.append("upiId", upiId);
    formData.append("invitationHistoryRequestDto.templateId", tid);
    formData.append(
      "invitationHistoryRequestDto.sharingModeType",
      "SELF_SHARE",
    );
    formData.append("invitationHistoryRequestDto.sourceMediaId", imageId);
    formData.append("invitationHistoryRequestDto.base64", base64Img);
    formData.append(
      `invitationHistoryRequestDto.invitationDetailsProvided`,
      invitationDetailsWa,
    );

    setLoading(true);
    axios
      .post(`${BASE_URL_EVENT}/invitation/card/display`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        const inviteId = response.data.payload.invitationId;
        const inviteIdString = inviteId.toString();
        window.next_page.postMessage(inviteIdString);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      })
      .finally(setLoading(false));
  }

  const handleWhatsAppShare = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("eventId", 10);
    formData.append("eventOptionRequestDto.accomodationFlag", accomodation);
    formData.append("eventOptionRequestDto.flightFlag", fligth);
    formData.append("eventOptionRequestDto.requestRSVP", rsvp);
    formData.append("eventOptionRequestDto.allowCommentsWall", comment);
    formData.append(
      "eventOptionRequestDto.authorizeMemeberToManage",
      authorize,
    );
    formData.append("eventOptionRequestDto.eshagunFlag", eshagun);
    formData.append("eventRequestDTO.eventName", eventName);
    formData.append("eventRequestDTO.eventType", eventType);
    formData.append("eventRequestDTO.venue", address1);
    formData.append("eventRequestDTO.venuePincode", venuePinCode);
    formData.append("eventRequestDTO.eventDetails", eventDetails);
    formData.append("eventRequestDTO.eventTiming", eventTiming);
    formData.append("eventRequestDTO.expectedNoOfGuests", expectedNoOfGuests);
    formData.append("eventRequestDTO.venueImg", imageId);
    authorizeMemberList.forEach((inputFields, index) => {
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberName`,
        inputFields.name,
      );
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberMobileNo`,
        inputFields.mobile,
      );
    });
    formData.append("upiId", upiId);
    formData.append("invitationHistoryRequestDto.templateId", tid);
    formData.append(
      "invitationHistoryRequestDto.sharingModeType",
      "SELF_SHARE",
    );
    formData.append("invitationHistoryRequestDto.sourceMediaId", imageId);
    formData.append("invitationHistoryRequestDto.base64", base64Img);
    formData.append(
      `invitationHistoryRequestDto.invitationDetailsProvided`,
      invitationDetailsWa,
    );

    axios
      .post(`${BASE_URL_EVENT}/invitation/card/display`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        const htmlurl = response.data.payload.sharingImgUrl;
        const whatsappUrl = `https://wa.me/send?text=${htmlurl}`;
        window.open(whatsappUrl);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  useEffect(() => {
    setActiveTab(1);
  }, []);

  const handlePreview = () => {
    let dt = canvas.toDataURL();
    setPreviewRes(dt);
  };

  useEffect(() => {
    handlePreview();
  }, []);

  const base64Img = previewRes.replace("data:image/png;base64,", "");

  const OverlayOne = () => (
    <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
  );

  const [overlay, setOverlay] = React.useState(<OverlayOne />);

  return (
    <Box
      style={{
        backgroundImage: `url(${invitationBG})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover", // You can adjust this based on your needs
        border: "1px solid black",
        paddingBottom: 10,
        marginBottom: 1,
      }}
    >
      {webview ? (
        <h1
          className="text-2xl sm:text-3xl font-bold flex justify-center sm:justify-start pt-4 sm:pt-10 fontfamily-oswald"
          style={{ fontFamily: "Oswald, sans-serif" }}
        >
          CUSTOMIZE CARD
        </h1>
      ) : null}

      <Flex
        borderRadius={10}
        p={5}
        m={2}
        textAlign={"left"}
        flexDir={{ base: "column", md: "row" }}
      >
        <Box w={{ base: "100%", md: "70%" }} p={5}>
          <Image src={previewRes} margin={"auto"} borderRadius={10} />

          {webview ? (
            <Box margin={"auto"} w={"100%"} display={"flex"} cursor={"pointer"}>
              <button
                className="text-[#fff] bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 rounded-[20px] text-sm font-semibold px-5 py-2.5 text-center"
                onClick={exitWebView}
              >
                {isLoading ? "Loading.." : "Continue"}
              </button>
            </Box>
          ) : null}
        </Box>
        <Box
          bgColor={`gray.100`}
          w={{ base: "100%", md: "50%" }}
          boxShadow={
            "rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;"
          }
          borderRadius={10}
          px={5}
          py={2}
        >
          <Flex gap={10} alignItems={"center"} justifyContent={"space-between"}>
            <Text fontWeight={"bold"} mt={2}>
              Event Details
            </Text>
          </Flex>
          <Box
            border={"1px solid black"}
            mt={1}
            w={"100%"}
            px={4}
            py={2}
            h={170}
            borderRadius={5}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}>Event Type</Text>
                <Input
                  size={{ base: "xs", md: "sm" }}
                  placeholder="Event Type"
                  h={8}
                  value={eventType}
                  onChange={(e) => seteventType(e.target.value)}
                />
              </Box>
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}>Event Name</Text>
                <Input
                  size={{ base: "xs", md: "sm" }}
                  placeholder="Event Name"
                  h={8}
                  value={eventName}
                  onChange={(e) => seteventName(e.target.value)}
                />
              </Box>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between">
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}>Event Details</Text>
                <Input
                  size={{ base: "xs", md: "sm" }}
                  placeholder="Event Details"
                  h={8}
                  value={eventDetails}
                  onChange={(e) => seteventDetails(e.target.value)}
                />
              </Box>
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}>Event Timing</Text>
                <Input
                  size={{ base: "xxs", md: "sm" }}
                  placeholder="Event Timing"
                  h={8}
                  type="datetime-local"
                  value={eventTiming}
                  onChange={(e) => seteventTiming(e.target.value)}
                />
              </Box>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between">
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}>Expected Guest</Text>
                <FormControl isRequired>
                  <Input
                    size={{ base: "xxs", md: "sm" }}
                    placeholder="Expected Number Of Guests"
                    h={8}
                    value={expectedNoOfGuests}
                    type="number"
                    onChange={(e) => setexpectedNoOfGuests(e.target.value)}
                  />
                </FormControl>
              </Box>
            </Flex>
          </Box>
          <Flex gap={10} alignItems={"center"} justifyContent={"space-between"}>
            <Text fontWeight={"bold"} mt={2}>
              Venue Details
            </Text>
          </Flex>
          <Box
            border={"1px solid black"}
            mt={1}
            w={"100%"}
            px={4}
            py={2}
            h={150}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}> Address</Text>
                <Input
                  size={{ base: "xs", md: "sm" }}
                  placeholder="address line 1"
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                />
              </Box>
              <Box w="45%" fontSize={12}>
                <Text fontWeight={"semibold"}>Pincode</Text>
                <Input
                  size={{ base: "xs", md: "sm" }}
                  placeholder="Pincode"
                  value={venuePinCode}
                  type="number"
                  onChange={(e) => setvenuePinCode(e.target.value)}
                />
              </Box>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between">
              <Flex
                w="80%"
                fontSize={12}
                gap={2}
                alignItems={"center"}
                flexDirection={{ base: "column", md: "row" }}
              >
                <Box w={{ base: "100%", md: "30%" }} mt={"2"}>
                  <Text fontWeight={"semibold"}>Add Images Max 10</Text>
                  <Input
                    size={{ base: "xxs", md: "sm" }}
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileChange}
                  />
                </Box>
                <Button
                  border={"1px"}
                  w={{ base: "100%", md: "30%" }}
                  size={{ base: "xs", md: "sm" }}
                  onClick={handleImage}
                  colorScheme="green"
                >
                  Upload Image
                </Button>
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              </Flex>
            </Flex>
            <Box>
              <Flex gap={4} mt="2" overflowY={"auto"} pb="2">
                {Array.isArray(selectedImages) ? (
                  selectedImages.map((file, index) => (
                    <Image
                      src={URL.createObjectURL(file)}
                      alt={`Selected Image ${index}`}
                      key={index}
                      w="20%"
                      h="20"
                    />
                  ))
                ) : (
                  <p>No images selected</p>
                )}
              </Flex>
            </Box>
          </Box>
          <Flex
            flexDirection={{ base: "column", md: "row" }}
            mt={6}
            justifyContent={{ base: "center", md: "space-evenly" }}
          >
            <Switch
              onChange={() => {
                setRsvp(!rsvp);
              }}
              fontSize={{ base: "12px", md: "18px" }}
              colorScheme="green"
            >
              Request RSVP
            </Switch>
            <Switch
              mt={{ base: "2", md: "0" }}
              mb={{ base: "4", md: "0" }}
              onChange={() => {
                setEshagun(!eshagun);
              }}
              fontSize={{ base: "12px", md: "18px" }}
              colorScheme="green"
            >
              Allow Eshagun
            </Switch>
          </Flex>

          <Box>
            {eshagun ? (
              <Box
                w={{ base: "100%", md: "50%" }}
                mt={{ base: "6", md: "4" }}
                margin={"auto"}
              >
                <Input
                  placeholder="UPI ID"
                  size={{ base: "xs", md: "sm" }}
                  value={upiId}
                  onChange={(e) => setupiId(e.target.value)}
                />
              </Box>
            ) : null}
          </Box>

          <Flex
            gap={10}
            boxShadow={
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;"
            }
            w={"60%"}
            m={"auto"}
            mt={2}
            justifyContent={"center"}
          ></Flex>
        </Box>
      </Flex>

      <Box textAlign={"center"} m={2}>
        {/* Action Buttons */}
        <Box textAlign={"center"}>
          {webview ? null : (
            <Box bgColor="gray.200" h={"80%"} w={"80%"} margin={"auto"} p={"2"}>
              <Text
                textAlign={"center"}
                fontSize={{ base: "18px", md: "14px" }}
                fontWeight={"semibold"}
              >
                Share Via:
              </Text>

              <Box w={{ base: "100%", md: "60%" }} margin={"auto"}>
                <Flex
                  mt={10}
                  justifyContent={"center"}
                  gap={5}
                  mb={2}
                  flexDir={{ base: "column", md: "row" }}
                >
                  <Box margin={"auto"} display={"flex"} cursor={"pointer"}>
                    <Text mr={"2"} color="blue" onClick={handleWhatsAppShare}>
                      WhatsApp
                    </Text>
                    <BiLogoWhatsapp size={"26"} color="green" />
                  </Box>

                  <Box margin={"auto"} display={"flex"} cursor={"pointer"}>
                    <Text
                      mr={"2"}
                      color="blue"
                      onClick={() => {
                        setOverlay(<OverlayOne />);
                        onOpen();
                      }}
                    >
                      {/* onClick={HandleSubmitEmail} */}
                      Send Invitations
                    </Text>
                    <BiLogoTelegram color="black" size={"26"} />

                    <Modal
                      isCentered
                      isOpen={isOpen}
                      size={{ base: "sm", md: "full" }}
                      onClose={onClose}
                    >
                      {overlay}
                      <ModalContent>
                        <ModalHeader>Share Invitation Via Mail</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                          {/* Mailing List Response */}
                          <Box>
                            {/*  <input type="file" onChange={handleFileUpload} />
                      <Table m={"auto"} w={"50%"}>
                        <Thead>
                          <Tr>
                            <Th>Name</Th>
                            <Th>Email</Th>
                            <Th>Mobile Number</Th>
                          </Tr>
                        </Thead>
                         <tbody>
      {invitationDetails.guests.map((entry, index) => (
        <tr key={index}>
          <td>{entry.name}</td>
          <td>{entry.email}</td>
          <td>{entry.mobile}</td>
        </tr>
      ))}
    </tbody>
                      </Table> */}

                            <Box>
                              <Flex flexDir={"row"}>
                                <Table variant="simple">
                                  <Thead>
                                    <Tr>
                                      <Th>Name</Th>
                                      <Th>Email</Th>
                                      <Th>Mobile Number</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {invitationDetails.guests &&
                                      invitationDetails.guests.map(
                                        (entry, index) => (
                                          <Tr key={index}>
                                            <Td>
                                              <Input
                                                type="text"
                                                name="name"
                                                value={entry.name}
                                                onChange={(e) =>
                                                  handleGuestNameChange(
                                                    index,
                                                    e,
                                                  )
                                                }
                                              />
                                            </Td>
                                            <Td>
                                              <Input
                                                type="email"
                                                name="email"
                                                value={entry.email}
                                                onChange={(e) =>
                                                  handleGuestEmailChange(
                                                    index,
                                                    e,
                                                  )
                                                }
                                              />
                                            </Td>
                                            <Td>
                                              <Input
                                                type="text"
                                                name="mobile"
                                                value={entry.mobile}
                                                onChange={(e) =>
                                                  handleGuestMobileChange(
                                                    index,
                                                    e,
                                                  )
                                                }
                                              />
                                            </Td>
                                            <Td>
                                              <Box>
                                                <Button
                                                  size={"xs"}
                                                  onClick={() =>
                                                    handleRemoveGuest(index)
                                                  }
                                                >
                                                  Remove Guest
                                                </Button>
                                              </Box>
                                            </Td>
                                            <Td>
                                              <Button
                                                size={"xs"}
                                                onClick={() =>
                                                  handleAddGuest(index)
                                                }
                                                colorScheme="green"
                                              >
                                                Add Guest
                                              </Button>
                                            </Td>
                                          </Tr>
                                        ),
                                      )}
                                  </Tbody>
                                </Table>
                              </Flex>
                            </Box>
                            <Button
                              margin={"auto"}
                              colorScheme="green"
                              size={"sm"}
                              onClick={HandleSubmitEmail}
                            >
                              Send Invitation
                            </Button>
                          </Box>
                        </ModalBody>
                        <ModalFooter>
                          <Button onClick={onClose}>Close</Button>
                        </ModalFooter>
                      </ModalContent>
                    </Modal>
                  </Box>

                  <Box margin={"auto"} display={"flex"} cursor={"pointer"}>
                    <Text mr={"2"} color={"blue"} onClick={handleDownload}>
                      Download Cards
                    </Text>
                    <BiDownload color="black" size={"26"} />
                  </Box>

                  {/*     <Box margin={"auto"} display={"flex"} cursor={"pointer"}>
              <Text mr={"2"} color="blue">
                Sharable URL
              </Text>
              <BiLink color="black" size={"26"} />
            </Box> */}
                  {/*         
         <Button colorScheme="teal" onClick={exportToExcel}>
          Export to Excel
        </Button> 
      */}
                </Flex>
              </Box>
            </Box>
          )}

          {webview ? (
            <Box margin={"auto"} w={"100%"} display={"flex"} cursor={"pointer"}>
              <button
                className="text-[#fff] bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 rounded-[20px] text-sm font-semibold px-5 py-2.5 text-center"
                onClick={exitWebView}
              >
                {isLoading ? "Loading.." : "Continue"}
              </button>
            </Box>
          ) : null}

          <Table m={"auto"} w={"50%"}>
            <Tbody>
              {guests.map((row, index) => (
                <Tr key={index}>
                  <Td>{row.Name}</Td>
                  <Td>{row.Email}</Td>
                  <Td>{row["Mobile Number"]}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
        <Text fontWeight={"semibold"} mt={2}>
          {downloading ? "You can download in 5 minutes.!" : ""}
        </Text>
      </Box>
    </Box>
  );
};

export default NextRsvp;
